var _rect, _path, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 1.5,
    fill: "#080F20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 19.1042C9.80554 18.6042 9.61109 18.1007 9.49998 17.5938C9.38887 17.0868 9.33331 16.5694 9.33331 16.0417C9.33331 14.2222 9.98956 12.6562 11.3021 11.3438C12.6146 10.0312 14.1805 9.375 16 9.375H16.8958L15.2291 7.70833L16.0416 6.89583L19.1458 10L16.0416 13.1042L15.2083 12.2708L16.8541 10.625H16C14.5139 10.625 13.2396 11.1562 12.1771 12.2188C11.1146 13.2812 10.5833 14.5556 10.5833 16.0417C10.5833 16.4444 10.6215 16.8264 10.6979 17.1875C10.7743 17.5486 10.868 17.8889 10.9791 18.2083L10.0833 19.1042ZM15.9166 25.1667L12.8125 22.0625L15.9166 18.9583L16.7291 19.7708L15.0625 21.4375H16C17.4861 21.4375 18.7604 20.9062 19.8229 19.8438C20.8854 18.7812 21.4166 17.5069 21.4166 16.0208C21.4166 15.6181 21.3819 15.2361 21.3125 14.875C21.243 14.5139 21.1389 14.1736 21 13.8542L21.8958 12.9583C22.1736 13.4583 22.3715 13.9618 22.4896 14.4688C22.6076 14.9757 22.6666 15.4931 22.6666 16.0208C22.6666 17.8403 22.0104 19.4062 20.6979 20.7188C19.3854 22.0312 17.8194 22.6875 16 22.6875H15.0625L16.7291 24.3542L15.9166 25.1667Z",
    fill: "#ECF1F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 1.5,
    stroke: "#262B92"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 1.5,
    stroke: "black",
    strokeOpacity: 0.25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.1d959d4934293a37f462cfb98721874b.svg";
export { ForwardRef as ReactComponent };